import React from "react";
import "./CommentForm.css";

function printStatus(state, mode=2){
    try{
        return printStatus0(state, mode);
    }
    catch (e){
        console.error(e);
        return null;
    }
}

function printStatus0(state, mode){
    const { objects } = state;
    let stageID = "";

    return(
        <div className="st-desc-body">
            <h3 className="st-desc-head">Общие сведения</h3>
            <div >{`Статус игры: ${gameStatus(state)}`}</div>
            <div>{`Режим игры: ${gameMode(state)}`}</div>
            <div>{`Порядок задач: ${gameScenario(state)}`}</div>
            <div>{`Сложность игры: ${gameDifficulty(state)}`}</div>
            <br/>
            {state.isGameInProgress ? 
            <>
            <h5>Сведения об игровой сессии</h5>
                <div className="ps-flex-string">
                    <div>{"Раунд игры: " + state.objects.roundCount}</div>
                    <div>{"Текущий вопрос раунда: " + state.objects.roundQstCount.current + " из " + state.objects.roundQstCount.max}</div>
                </div>
                <div className="ps-flex-string">
                    <div>{"Текущий счет: " + state.objects.score.current}</div>
                    <div>{"Максимально возможный счет: " + state.objects.score.max}</div>
                </div>
                <h3>Сводная информация по ответам на вопросы</h3>

            </> 
            : false}
            {/* {printHead(state, mode)}
            {(state.objects.checkpoint && state.objects.checkpoint.law) ? 
                    printStatusPrep({ objects }, mode) 
                : 
                    false
            }
            {(state.objects.checkpoint && state.objects.checkpoint.law) ? printNDTResult(objects, mode) : false}
            {objects.need ? printDocString(objects, mode) : false}
            {state.objects.applicationformdata ?
                    <>{printStatusTables(objects)}
                    <div className="show-application-form-button">
                        <ShowApplicationFormButton state={state} />
                    </div></>
                :
                    false
            } */}
        </div>
    )
}

function gameStatus(state){
    if(!state.objects.init) return "не началась";
    if(state.objects.endOfGame) return "завершена";
    else{
        return "в процессе";
    }
}

function gameDifficulty(state){
    if(state.objects.difficulty === undefined) return "не выбрана";
    if(state.objects.difficulty === 0) return "низкая";
    if(state.objects.difficulty === 1) return "высокая";
}

function gameScenario(state){
    if(state.objects.mode === undefined) return "не выбран";
    if(state.objects.mode === 0) return "фиксированный";
    if(state.objects.mode === 1) return "случайный";
}

function gameMode(state){
    if(state.objects.help === undefined) return "не выбран";
    if(state.objects.help === 0) return "обучающий";
    if(state.objects.help === 1) return "контрольный";
}

export default printStatus
